import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, CheckCircle2, ChevronDown } from 'lucide-react';
const tomos = [{
  id: 'T1',
  title: 'Mentalidad y Motivación',
  desc: 'La base que necesitas para dejar de abandonar.',
  bullets: ['Cómo crear disciplina real', 'Eliminar bloqueos mentales', 'Mantener motivación sostenible']
}, {
  id: 'T2',
  title: 'Rutinas Desde Casa',
  desc: 'Entrenamientos simples y efectivos.',
  bullets: ['Ejercicios para todos los niveles', 'Rutinas prácticas', 'Entrenamientos adaptables']
}, {
  id: 'T3',
  title: 'Hábitos Saludables',
  desc: 'Construye hábitos que realmente duren.',
  bullets: ['Organización diaria', 'Constancia sin agotamiento', 'Hábitos sostenibles']
}, {
  id: 'T4',
  title: 'Alimentación Inteligente',
  desc: 'Mejora tu físico sin dietas extremas.',
  bullets: ['Consejos simples de alimentación', 'Cómo mejorar tu energía', 'Relación saludable con la comida']
}, {
  id: 'T5',
  title: 'Energía y Bienestar',
  desc: 'Recupera tu equilibrio físico y mental.',
  bullets: ['Más energía diaria', 'Mejor descanso', 'Menos estrés y ansiedad']
}, {
  id: 'T6',
  title: 'Transformación Completa',
  desc: 'Convierte esto en un estilo de vida.',
  bullets: ['Cómo mantener resultados', 'Mentalidad de crecimiento', 'Evolución constante']
}];
export function Tomos() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-10 md:py-20 px-4 bg-zinc-950" data-id="element-220">
      <div className="max-w-6xl mx-auto" data-id="element-221">
        <div className="text-center mb-6 md:mb-16" data-id="element-222">
          <div className="inline-block bg-zinc-900 border border-zinc-800 px-3 py-1 rounded-full text-zinc-400 text-[10px] md:text-sm font-medium mb-2 md:mb-4 tracking-wider" data-id="element-223">
            TODO LO QUE INCLUYE
          </div>
          <h2 className="text-4xl md:text-7xl font-bebas text-white mb-1 md:mb-4" data-id="element-224">
            LOS 6 TOMOS
          </h2>
          <p className="text-sm md:text-xl text-zinc-400" data-id="element-225">
            Tu hoja de ruta paso a paso
          </p>
        </div>

        {/* Mobile: accordion-style compact cards */}
        <div className="md:hidden space-y-2" data-id="element-226">
          {tomos.map((tomo, i) => {
          const isOpen = open === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className={`bg-zinc-900 border rounded-xl overflow-hidden transition-colors ${isOpen ? 'border-brand-500/50' : 'border-zinc-800'}`} data-id="element-227">
                <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center gap-3 p-3 text-left" data-id="element-228">
                  <div className="w-10 h-10 shrink-0 rounded-lg bg-brand-500/10 border border-brand-500/20 flex items-center justify-center" data-id="element-229">
                    <span className="text-brand-500 font-bebas text-lg" data-id="element-230">
                      {tomo.id}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-231">
                    <h3 className="text-sm font-bold text-white leading-tight" data-id="element-232">
                      {tomo.title}
                    </h3>
                    <p className="text-zinc-400 text-[11px] leading-snug truncate" data-id="element-233">
                      {tomo.desc}
                    </p>
                  </div>
                  <ChevronDown className={`w-4 h-4 text-zinc-500 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-234" />
                </button>
                <AnimatePresence data-id="element-235">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-236">
                      <ul className="px-3 pb-3 pt-1 space-y-1.5 border-t border-zinc-800" data-id="element-237">
                        {tomo.bullets.map((bullet, j) => <li key={j} className="flex items-start gap-2 text-xs text-zinc-300 pt-1" data-id="element-238">
                            <CheckCircle2 className="w-3.5 h-3.5 text-brand-500 shrink-0 mt-0.5" data-id="element-239" />
                            <span data-id="element-240">{bullet}</span>
                          </li>)}
                      </ul>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        {/* Desktop grid */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-241">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} whileHover={{
          y: -4
        }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 relative overflow-hidden group hover:border-brand-500/50 transition-colors" data-id="element-242">
              <div className="absolute -right-4 -top-4 text-zinc-800/30 group-hover:text-brand-500/5 transition-colors" data-id="element-243">
                <BookOpen className="w-32 h-32" data-id="element-244" />
              </div>

              <div className="relative z-10" data-id="element-245">
                <div className="text-brand-500 font-bebas text-2xl mb-2" data-id="element-246">
                  📘 {tomo.id}
                </div>
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-247">
                  {tomo.title}
                </h3>
                <p className="text-zinc-400 text-sm mb-6 pb-6 border-b border-zinc-800" data-id="element-248">
                  {tomo.desc}
                </p>

                <ul className="space-y-3" data-id="element-249">
                  {tomo.bullets.map((bullet, j) => <li key={j} className="flex items-start gap-2 text-sm text-zinc-300" data-id="element-250">
                      <CheckCircle2 className="w-5 h-5 text-brand-500 shrink-0" data-id="element-251" />
                      <span data-id="element-252">{bullet}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}